<template>
    <BreadCrumb PageTitle="Liste des types de pièces" />
    <ListeTypePiece/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTypePiece from "../../components/TypePiece/ListeTypePiece.vue";

    export default defineComponent({
      name: "ListeTypePiecePage",
      components: {
        BreadCrumb,
        ListeTypePiece,
      },
    });
  </script>